import { useEffect, useRef } from "react";
import SocketService from "services/socket.service";
import AuthService from "services/auth.service";
import { useDispatch } from "react-redux";
import { showIncomingRequestModal } from "app/ondemandSlice";

export function OndemandSocket() {
  const dispatch = useDispatch();
  const isCancelledSocket = useRef(false);
  const socketInfo = AuthService.getSocketInfo();
  const currentUser = AuthService.getCurrentUser();
  const onDemandChannel = "/teleconsult_on_demand/doctors";
  const individualOnDemandChannel = "/teleconsult_on_demand/doctor/";

  /* remember to disconnect channel whenever logout */
  useEffect(() => {
    if (
      currentUser.user_type === "doctor" &&
      currentUser.is_bookdoc_nutritionist !== true
    ) {
      var authToken = currentUser?.auth_token;

      SocketService.setHeader(authToken, socketInfo);
      SocketService.subscribe(onDemandChannel, null, function (data) {
        if (data) {
          dispatch(showIncomingRequestModal(data));
        }
      });
      SocketService.subscribe(individualOnDemandChannel, socketInfo, function (data) {
        if (data) {
          dispatch(showIncomingRequestModal(data));
        }
      });
    }
    return () => {
      isCancelledSocket.current = true;
    };
  }, [currentUser]); // eslint-disable-line

  return null;
}

export default OndemandSocket;
